// App.js
import { Routes, Route, useLocation } from "react-router-dom";


import "react-quill/dist/quill.snow.css";

import Home from "./compnent/home/Home";
import Dashboard from "./compnent/Dashboard/Dashboard.jsx";
import ResetPassword from "./compnent/login/resetPassword/resetPassword.jsx";
import ForgotPassword from "./compnent/login/forgotpassword/forgotPassword.jsx";

import Login from "./compnent/login/login/login.jsx";
import SignUp from "./compnent/login/signup/signup.jsx";
import VerifyEmail from "./compnent/login/verifyEmail/verifyEmail.jsx";

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { loadUserAction } from "./redux/actions/userActions.js";
import PageNotFound from "./compnent/PageNotFound/PageNotFound.jsx";
import Profile from "./compnent/profile/Profile.jsx";
import AddUser from "./compnent/Dashboard/InviteUsers.jsx";
import AddProdcuts from "./compnent/Prodcuts/AddProducts.jsx";
import SystemConfiguration from "./compnent/Dashboard/SystemConfiguration.jsx";
import AdditionalInformation from "./compnent/login/Additionalinformation/Additionalinformation.jsx";
import ChangePassword from "./compnent/profile/ChangePassword.jsx";
import Admins from "./compnent/Dashboard/adminList/Admins.jsx";
import PmmList from "./compnent/Dashboard/PMMList/PMMlist.jsx";
import SingleUser from "./compnent/Dashboard/singleUser/SingleUser.jsx";
import ProductDetails from "./compnent/Prodcuts/AllProducts/ProductDetails/productDetails.jsx";
import Reservations from "./compnent/reservations/Reservations.jsx";
import CreateOrder from "./compnent/orders/createOrder/CreateOrder.jsx";
import AllOrders from "./compnent/orders/allOrders/AllOrders.jsx";
import ReviewTheOrder from "./compnent/orders/reviewTheOrder/ReviewTheOrder.jsx";
import OnHoldTheOrder from "./compnent/orders/onHoldTheOrder/OnHoldTheOrder.jsx";
import OrderRefunded from "./compnent/orders/orderRefunded/OrderRefunded.jsx";
import ReviewDeleted from "./compnent/orders/ReviewDeleted/ReviewDeleted.jsx";
import ReportOnOrder from "./compnent/orders/ReportOnOrder/ReportOnOrder.jsx";
import PMList from "./compnent/Dashboard/PMList/PMlist.jsx";
import AllProducts from "./compnent/Prodcuts/AllProducts/AllProducts.jsx";
import UpdateProduct from "./compnent/Prodcuts/AllProducts/updateProduct/UpdateProduct.jsx";
import SingleOrder from "./compnent/orders/singleOrder/SingleOrder.jsx";
import DelayedRefunds from "./compnent/delayedRefunds/AllOrders.jsx";
import OrderReports from "./compnent/order-reports/OrderReports.jsx";
import Notifications from "./compnent/notifcations/Notifications.jsx";
import CommissionCalculation from "./compnent/CommissionCalculation/CommissionCalculation.jsx";
import BalanceOverview from "./compnent/Dashboard/balanceOverview/BalanceOverview.jsx";
import InviteList from "./compnent/Dashboard/userInvites/InviteLists.jsx";
import BlockedMails from "./compnent/BlockedMails/BlockedMails.jsx";
import PMMpending from "./compnent/pmmPending/PMMpending.jsx";
import IncomingCommission from "./compnent/IncompingCommission/IncomingCommission.jsx";
import OutGoingCommission from "./compnent/OutgoingCommission/OutGoingCommission.jsx";
import RemarksOnOrder from "./compnent/orders/RemarksOnOrder/RemarksOnOrder.jsx";
import UnderContruction from "./compnent/UnderContruction.jsx";
import Messenger from "./compnent/Messenger/Messenger.jsx";
import OtherUserDetails from "./compnent/OtherUserDetails/OtherUserDetails.jsx";
import ExportOrders from "./compnent/ExportExcel.jsx";
import UploadProgressBar from "./compnent/home/UploadProgressBar.jsx"

import AOS from "aos";
import "aos/dist/aos.css";
import ManualSignup from "./compnent/login/signup/ManualSignup.jsx";
import PendingApproval from "./compnent/login/PendingApproval.jsx";
import PendingApprovals from "./compnent/PendingApprovals/PendingApprovals.jsx";
import Support from "./compnent/home/Support.jsx";
import { useTheme } from "./theme.js";
import ThemeSwitcher from "./compnent/theme/ThemeSwitcher.jsx";
import GlobalNotifications from "./compnent/GlobalNotifications.jsx";


const App = () => {
  const dispatch = useDispatch();
  const { effectiveTheme } = useTheme();
  const location = useLocation();


  const [showSupport, setShowSupport] = useState(false)
  const showPublicThemeSwitcher = [
    "/login/",
    "/user-signup/",
    "/verify-email/",
    "/forgot-password/",
    "/add-user-details/",
    "/pending-approval/",
  ].some(path => location.pathname.startsWith(path)) ||
    location.pathname.startsWith("/signup/") ||
    location.pathname.startsWith("/reset-password/");



  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(loadUserAction());
    }, 0);

    return () => clearTimeout(timer);
  }, [dispatch]);



  useEffect(() => {
    AOS.init({
      duration: 1500,        // animation duration
      once: true,           // ✅ animate only once (IMPORTANT)
      easing: "ease-in-out",
      offset: 0,          // trigger before element comes fully into view
    });
  }, []);


  return (
    <>
      <ToastContainer
        position={window.innerWidth < 600 ? "bottom-center" : "bottom-right"}
        autoClose={1500}
        theme={effectiveTheme === "dark" ? "dark" : "colored"}
        pauseOnHover
        hideProgressBar={false}
      />
      <GlobalNotifications />
      <UploadProgressBar  />

      <Support showSupport={showSupport} setShowSupport={setShowSupport} />
      {showPublicThemeSwitcher && <ThemeSwitcher variant="floating" />}


      <Routes>
        <Route path="/" element={<Home  setShowSupport={setShowSupport}  />}>

          {/* Dashboard */}

          <Route index element={<Dashboard />} />
          <Route path="/dashboard/invite-users" element={<AddUser />} />
          <Route path="/dashboard/system-configuration" element={<SystemConfiguration />} />
          <Route path="/dashboard/admins" element={<Admins />} />
          <Route path="/dashboard/pmm-list" element={<PmmList />} />
          <Route path="/dashboard/pm-list" element={<PMList />} />
          <Route path="/dashboard/user-details" element={<SingleUser />} />
          <Route path="/dashboard/balance-overview" element={<BalanceOverview />} />
          <Route path="/dashboard/invites-list" element={<InviteList />} />
          <Route path="/dashboard/pending-approvals" element={<PendingApprovals />} />

          {/* commissions */}

          <Route path="/commissions/pm-pending" element={<CommissionCalculation />} />
          <Route path="/commissions/pmm-pending" element={<PMMpending />} />
          <Route path="/commissions/incoming-commissions" element={<IncomingCommission />} />
          <Route path="/commissions/outgoing-commissions" element={<OutGoingCommission />} />


          {/* prodcuts */}

          <Route path="/products/add-product" element={<AddProdcuts />} />
          <Route path="/products/all-products" element={<AllProducts />} />
          <Route path="/products/single-product" element={<ProductDetails />} />
          <Route path="/products/update-product" element={<UpdateProduct />} />


          {/* profile */}
          <Route path="/profile" element={<Profile />} />
          <Route path="/change-password/" element={<ChangePassword />} />


          {/* reservations */}

          <Route path="/reservations" element={<Reservations />} />


          {/* excel report and blocked mails */}

          <Route path="/blocked-mails" element={<BlockedMails />} />


          {/* orders */}
          <Route path="/orders/create-order" element={<CreateOrder />} />
          <Route path="/orders/all-orders" element={<AllOrders />} />
          <Route path="/orders/review-order" element={<ReviewTheOrder />} />
          <Route path="/orders/on-hold" element={<OnHoldTheOrder />} />
          <Route path="/orders/order-refunded" element={<OrderRefunded />} />
          <Route path="/orders/review-deleted" element={<ReviewDeleted />} />
          <Route path="/orders/report-order" element={<ReportOnOrder />} />
          <Route path="/orders/order-details" element={<SingleOrder />} />
          <Route path="/delayed-refunds" element={<DelayedRefunds />} />
          <Route path="/order-reports" element={<OrderReports />} />
          <Route path="/orders/remarks-on-order" element={<RemarksOnOrder />} />



          <Route path="/notifications" element={<Notifications />} />



          {/* messenger */}
          <Route path="/messenger" element={<Messenger />} />



          <Route path="/support" element={<UnderContruction />} />
          <Route path="/create-excel-reports" element={<ExportOrders />} />



          <Route path="/edit-profile/other-user-details" element={<OtherUserDetails />} />





        </Route>

        <Route path="/login/" element={<Login />} />
        <Route path="/signup/:token" element={<SignUp />} />
        <Route path="/user-signup/" element={<ManualSignup />} />
        <Route path="/verify-email/" element={<VerifyEmail />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="/forgot-password/" element={<ForgotPassword />} />
        <Route path="/add-user-details/" element={<AdditionalInformation />} />
        <Route path="/pending-approval/" element={<PendingApproval setShowSupport={setShowSupport} />} />
        <Route path="/*" element={<PageNotFound />} />

      </Routes>
    </>
  );
};

export default App;
